import { IconButton, styled } from "@mui/material";
import Circles from "../../svgs/Circles.svg";

const CustomIconButton = styled(IconButton)({
  height: "30px",
  width: "30px",
});

export function MenuActionButton({ onClick }) {
  return (
    <CustomIconButton onClick={onClick}>
      <img src={Circles} />
    </CustomIconButton>
  );
}
